import {
  Box,
  Button,
  Container,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  TextField,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Logo from "../../../assets/logo.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import JusttawkBg from "../../../assets/justtawk-bg.png";
import JusttawkLogo from "../../../assets/Justtawk-01.png";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axiosInstance from "../../../services/axiosInstance";

const countryOptions = [
  { label: "🇦🇪 UAE", value: "UAE" },
  { label: "🇺🇸 USA", value: "USA" },
  { label: "🇮🇳 India", value: "IND" },
];

const Number = () => {
  const navigate = useNavigate();
  const [phoneDetails, setPhoneDetails] = useState([]);
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [countryDialogOpen, setCountryDialogOpen] = useState(true);

  const getPhoneNumber = async (country) => {
    try {
      const response = await axiosInstance.get(
        `${apiEndPointsConfig.getDidNumber}/${country}`
      );
      setPhoneDetails(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCountryConfirm = async () => {
    if (!selectedCountry) return;
    setCountryDialogOpen(false);
    // Save country to user profile
    try {
      await axiosInstance.post(
        `${apiEndPointsConfig.singleUserFieldDetails}`,
        { country: selectedCountry, dropoff: "number selection" }
      );
    } catch (error) {
      console.log("Error saving country:", error);
    }
    // Fetch DID numbers for selected country
    getPhoneNumber(selectedCountry);
  };

  const sendDetailOnMail = async () => {
    try {
      const res = await axiosInstance.get(
        `${apiEndPointsConfig.sendFaqDetailsOnMail}/${userId}`
      );
    } catch (error) {
      console.log(error);
    }
  };

  const addPhoneNumber = async (data) => {
    const access_token = token;

    try {
      const response = await axiosInstance.post(
        `${apiEndPointsConfig.saveDidNumber}`,
        data
      );
      if ((response.status = true)) {
        sendDetailOnMail();
        navigate("/loading");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      selectedNumber: "",
    },
    validationSchema: Yup.object({
      selectedNumber: Yup.string().required("Please select a phone number"),
    }),
    onSubmit: (values) => {
      const data = {
        didId: values.selectedNumber,
        userId: userId,
        dropoff: "demo",
        country: selectedCountry,
      };
      console.log(data);
      addPhoneNumber(data);
    },
  });

  const handleChange = (e) => {
    console.log(e.target.value, "aa");

    const { value, name } = e.target;
    const selectedPhone = phoneDetails.find((phone) => phone.did_id === value);

    if (selectedPhone) {
      localStorage.setItem("selectedPhone", selectedPhone.did_alias);
    }
    formik.setFieldValue(name, value);
  };

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
      }}
    >
      {/* Country Selection Popup */}
      <Dialog
        open={countryDialogOpen}
        disableEscapeKeyDown
        PaperProps={{
          style: {
            width: "420px",
            borderRadius: "12px",
            padding: "10px",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 900,
            fontSize: "1.3rem",
            textAlign: "center",
          }}
        >
          Select Your Country
          <Typography
            sx={{
              fontSize: "0.85rem",
              color: "#6D6D6D",
              mt: 0.5,
            }}
          >
            Choose your country to see available customer care numbers
          </Typography>
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mt: 1 }}>
            <InputLabel id="country-select-label">Country</InputLabel>
            <Select
              labelId="country-select-label"
              id="country-select"
              value={selectedCountry}
              label="Country"
              onChange={(e) => setSelectedCountry(e.target.value)}
              sx={{ borderRadius: "8px" }}
            >
              {countryOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            disabled={!selectedCountry}
            onClick={handleCountryConfirm}
            sx={{
              textTransform: "capitalize",
              px: 5,
              borderRadius: "8px",
            }}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>

      <Grid container>
        <Grid
          item
          md={9.5}
          xs={12}
          sx={{
            height: {
              xs: "100%",
              md: "100%",
            },
          }}
        >
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            sx={{
              height: {
                xs: "50vh",
                md: "100vh",
              },
              backgroundImage: {
                xs: `url(${JusttawkBg})`,
              },
              backgroundRepeat: "no-repeat",
              backgroundColor: (t) => t.palette.primary.main,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
              color: "white",
              display: { xs: "flex", md: "none" },
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              p: { xs: "20px", md: "100px 0" },
              mt: {
                xs: "-100px",
                md: "0px",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: {
                    xs: 400,
                    md: 900,
                  },
                  fontSize: {
                    xs: "1.1rem",
                    md: "1.8rem",
                  },
                  mt: {
                    xs: "50px",
                    md: "0px",
                  },
                  whiteSpace: "nowrap",
                }}
              >
                Welcome to{" "}
                <Box
                  sx={{
                    display: { xs: "flex", md: "none" }, // Show image on mobile, hide on md and larger
                    justifyContent: "center",
                    alignItems: "center",
                    p: "7px 0",
                  }}
                >
                  <img
                    src={JusttawkLogo}
                    alt="Justtawk Logo"
                    style={{
                      height: "auto", // Keep aspect ratio intact
                      maxWidth: "100%", // Ensure the image does not exceed container width
                      width: "220px", // Set a fixed width for the image
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: { xs: "none", md: "inline" }, // Show text on md and larger
                  }}
                >
                  Justtawk
                </Box>
              </Typography>

              <Typography
                sx={{
                  fontWeight: {
                    xs: 400,
                    md: 100,
                  },
                  fontSize: "1rem",
                }}
              >
                Your Gateway to Effortless Call Center.
              </Typography>
            </Box>
          </Grid>

          <Box
            sx={{
              p: "5px 10px",
            }}
          >
            <Box
              sx={{
                height: "8vh",
                display: {
                  xs: "none",
                  md: "flex",
                },
              }}
            >
              <img src={Logo} alt="Logo" height="100%" width="200" />{" "}
            </Box>
          </Box>
          <Container>
            <Box
              sx={{
                padding: {
                  xs: "20px 0px 0 0px",
                  md: "50px 0px 0 100px",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "2rem",
                    md: "2.5rem",
                  },
                  fontWeight: 900,
                  textAlign: {
                    xs: "center",
                    md: "initial",
                  },
                  lineHeight: {
                    xs: "40px",
                    md: "60px",
                  },
                }}
              >
                Select your Customer Care Number
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "1rem",
                    md: "1.4rem",
                  },
                  fontWeight: 100,
                  lineHeight: {
                    md: "25px",
                  },
                  color: {
                    xs: "black",
                    md: "#6D6D6D",
                  },
                  mt: "0px",
                  textAlign: {
                    xs: "center",
                    md: "initial",
                  },
                  p: {
                    xs: "0 50px",
                    md: "0",
                  },
                }}
              >
                Start getting calls by just selecting your call center number
              </Typography>
            </Box>

            <Grid
              container
              sx={{
                mt: {
                  xs: "10px",
                  md: "20px",
                },
                padding: {
                  xs: "0 0 0 0px",
                  md: "0 0 0 100px",
                },
              }}
            >
              <Grid item xs={12} md={12}>
                <Box>
                  <Box
                    sx={{
                      display: {
                        xs: "flex",
                        md: "initial",
                      },
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <FormLabel
                      component="legend"
                      sx={{
                        fontSize: "0.8rem",
                        fontWeight: 10,
                        pb: "10px",
                        display: {
                          xs: "none",
                          md: "flex",
                        },
                      }}
                    >
                      We found best number for your business
                    </FormLabel>

                    <form onSubmit={formik.handleSubmit}>
                      <Box
                        sx={{
                          minHeight: { xs: 220, md: 350 },
                          maxHeight: { xs: "30vh", md: 350 },
                          overflowY: "auto",
                          overflowX: "hidden",
                          pr: 1,
                          WebkitOverflowScrolling: "touch",
                          "&::-webkit-scrollbar": { width: 8 },
                          "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "rgba(0,0,0,0.2)",
                            borderRadius: 8,
                          },
                        }}
                      >
                        <FormControl component="fieldset">
                          <RadioGroup
                            aria-label="number"
                            name="selectedNumber"
                            value={formik.values.selectedNumber}
                            onChange={handleChange} // Use the custom handleChange
                          >
                            {phoneDetails.map((number) => (
                              <FormControlLabel
                                key={number?._id}
                                value={number?._id}
                                control={<Radio />}
                                label={
                                  <span>
                                    {number?.did_alias}
                                    {number?.langSupport ? (
                                      <strong style={{ marginLeft: 10 }}>
                                        (
                                        {Array.isArray(number.langSupport)
                                          ? number.langSupport.join(", ")
                                          : number.langSupport}
                                        )
                                      </strong>
                                    ) : null}
                                  </span>
                                }
                                onChange={() => {
                                  localStorage.setItem(
                                    "selectedPhone",
                                    number?.did_alias
                                  );
                                }}
                              />
                            ))}
                          </RadioGroup>
                          {formik.touched.selectedNumber &&
                          formik.errors.selectedNumber ? (
                            <Typography color="error">
                              {formik.errors.selectedNumber}
                            </Typography>
                          ) : null}
                        </FormControl>
                      </Box>

                      <Grid
                        item
                        sx={{
                          display: "flex",
                          justifyContent: {
                            xs: "center",
                            md: "flex-end",
                          },

                          p: {
                            xs: "20px 0 10px 0",
                            md: "30px 0 10px 0",
                          },
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          sx={{
                            whiteSpace: "nowrap",
                            textTransform: "capitalize",
                          }}
                        >
                          Submit
                        </Button>
                      </Grid>
                    </form>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Grid>
        <Grid
          item
          xs={12}
          md={2.5}
          sx={{
            background: "#1A5CB0",
            padding: "0 0px 50px 0",
            display: {
              xs: "none",
              md: "initial",
            },
          }}
        >
          <Typography
            sx={{
              fontSize: "1.2rem",
              color: "white",
              fontWeight: 900,
              p: "100px 20px 40px 20px",
            }}
          >
            Quick & Easy Setup
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Stepper
              activeStep={3}
              orientation="vertical"
              sx={{
                color: "white",
                "& .MuiStepLabel-label": {
                  color: "white",
                },
              }}
            >
              <Step>
                <StepLabel>
                  <Typography
                    sx={{
                      color: "#6198DE",
                      fontSize: "0.8rem",
                      ml: 1,
                      mb: 0, // Remove bottom margin
                    }}
                  >
                    Business Details
                  </Typography>
                </StepLabel>
              </Step>
              <Step>
                <StepLabel>
                  <Typography
                    sx={{
                      color: "#6198DE",
                      fontSize: "0.8rem",
                      ml: 1,
                      mb: 0, // Remove bottom margin
                    }}
                  >
                    Define Frequently Ask Questions
                  </Typography>
                </StepLabel>
              </Step>
              <Step>
                <StepLabel>
                  <Typography
                    sx={{
                      color: "white",
                      fontSize: "0.8rem",
                      ml: 1,
                      mb: 0, // Remove bottom margin
                    }}
                  >
                    Select Customer Care Number
                  </Typography>
                </StepLabel>
              </Step>
            </Stepper>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Number;
